module.exports = __webpack_public_path__ + "static/media/CUP-logo300.6dda73e9.png";